// src/api.js
// Percorso API - usa il proxy del frontend per inoltrare le richieste al backend (porta 3001)
const LOCAL_API = "http://localhost:3001/api";
const PROD_API  = "https://joinjkl.com/api";
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (window.location.hostname.includes("joinjkl.com") ? PROD_API : LOCAL_API);
console.log("[API.JS LOADED]", { API_BASE, t: Date.now() });

// Usa l'origine di API_BASE per i file (upload/download)
export const FILE_ORIGIN = (() => {
  try {
    return new URL(API_BASE, window.location.origin).origin; // es. http://localhost:3000 → proxy verso 3001
  } catch {
    return window.location.origin; // fallback
  }
})();



/* ========== Token helpers ========== */
function readToken() {
  try { return localStorage.getItem('token') || ''; } catch { return ''; }
}
function writeToken(t) {
  try {
    if (t) localStorage.setItem('token', t);
    else localStorage.removeItem('token');
  } catch {}
}
function redirectToLoginIfNeeded() {
  if (typeof window === 'undefined') return;
  const here = window.location.pathname + window.location.hash;
  const loginRoutes = ['/login', '/signin', '/auth/login', '/#/login', '/#/signin'];
  const alreadyOnLogin = loginRoutes.some(r => here.includes(r));
  if (!alreadyOnLogin) window.location.href = '/login';
}

/* ========== Headers builders ========== */
export function authHeaders() {
  const t = readToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
function buildHeaders(options = {}) {
  const headers = { ...(options.headers || {}), ...authHeaders() };
  const hasBody   = options.body != null;
  const isFormData = options.body instanceof FormData;
  // Aggiungi Content-Type SOLO quando c'è un body non-FormData
  if (hasBody && !isFormData && !('Content-Type' in headers)) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}


/* ========== Timeout helper ========== */
function timeout(ms) {
  return new Promise((_, reject) =>
    setTimeout(() => reject(new Error(`Timeout dopo ${ms} ms`)), ms)
  );
}

/* ========== fetchJson (GET/POST/PUT/DELETE JSON) ========== */
export async function fetchJson(path, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
  const opts = { ...options, headers: buildHeaders(options) };

  const res = await Promise.race([fetch(url, opts), timeout(20000)]);

  if (res.status === 401) {
    writeToken('');
    redirectToLoginIfNeeded();
    throw new Error('Unauthorized');
  }

  if (res.status === 204 || res.headers.get('content-length') === '0') {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return null;
  }

  const ct = res.headers.get('content-type') || '';
  const isJson = ct.includes('application/json');
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const msg = isJson ? (payload?.error || JSON.stringify(payload)) : (payload || `HTTP ${res.status}`);
    throw new Error(msg);
  }
  return payload;
}

/* ========== fetchForm (upload con FormData) ========== */
export async function fetchForm(path, formData, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;

  const opts = {
    method: 'POST',
    ...options,
    body: formData,
    headers: { ...(options.headers || {}), ...authHeaders() }, // niente Content-Type: la mette il browser
  };

  const res = await Promise.race([fetch(url, opts), timeout(600000)]);

  if (res.status === 401) {
    writeToken('');
    redirectToLoginIfNeeded();
    throw new Error('Unauthorized');
  }

  if (res.status === 204 || res.headers.get('content-length') === '0') {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return null;
  }

  const ct = res.headers.get('content-type') || '';
  const isJson = ct.includes('application/json');
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const msg = isJson ? (payload?.error || JSON.stringify(payload)) : (payload || `HTTP ${res.status}`);
    throw new Error(msg);
  }
  return payload;
}

// Utility per costruire URL assoluti di file (immagini, allegati, ecc.)
// Costruisce URL assoluti per /uploads, evitando process.env nel browser
export function fileUrl(p) {
  if (!p) return '';
  if (/^https?:\/\//i.test(p)) return p; // già assoluto
  return `${FILE_ORIGIN}${p.startsWith('/') ? '' : '/'}${p}`;
}

// === AI: Sintesi profilo automatica ===
export async function fetchAISummary(freelancerId) {
  try {
    // quando il backend sarà pronto, questo endpoint risponderà con { summary: "..." }
    const data = await fetchJson(`/ai/summary/${encodeURIComponent(freelancerId)}`);
    return data?.summary || null;
  } catch (err) {
    console.warn('AI summary fetch failed, fallback al locale:', err);
    return null; // fallback, così il frontend userà la generazione locale
  }
}

export async function setFavoriteFreelancer(freelancerId, enabled) {
  if (enabled) return fetchJson('/favorites', { method: 'POST', body: JSON.stringify({ freelancerId }) });
  return fetchJson(`/favorites/${encodeURIComponent(freelancerId)}`, { method: 'DELETE' });
}

export async function upsertAvailabilityAlert(freelancerId, leadDays) {
  if (leadDays == null) return fetchJson(`/alertsjobs/availability/${encodeURIComponent(freelancerId)}`, { method: 'DELETE' });
  return fetchJson('/alertsjobs/availability', { method: 'POST', body: JSON.stringify({ freelancerId, leadDays }) });
}

export async function setPriorityFreelancer(freelancerId, enabled) {
  if (enabled) {
    return fetchJson('/priorities', {
      method: 'POST',
      body: JSON.stringify({ freelancerId })
    });
  }
  return fetchJson(`/priorities/${encodeURIComponent(freelancerId)}`, {
    method: 'DELETE'
  });
}

